import { Link } from "react-router-dom";
import { useContent } from "@/data/content";
import { NICHES } from "@/data/niches";
import { useAppTranslation } from "@/i18n/useAppTranslation";
import { useLocale } from "@/i18n/useLocale";

function Row({ items }: { items: readonly string[] }) {
  return (
    <ul className="flex shrink-0 items-center" aria-hidden="true">
      {items.map((item) => (
        <li key={item} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-display text-[clamp(1.4rem,2.6vw,2rem)] font-medium tracking-[-0.01em] text-brand-primary/80 transition-colors duration-300 hover:text-teal-strong">
            {item}
          </span>
          <span className="size-2 rounded-full bg-brand-secondary shadow-[0_0_0_4px_rgb(114_181_177/0.2)]" />
        </li>
      ))}
    </ul>
  );
}

export function NichesStrip() {
  const { niches, nichesLabel } = useContent().home;
  const { t } = useAppTranslation("common");
  const locale = useLocale();
  return (
    <section aria-label={nichesLabel} className="border-y border-brand-primary/8 bg-white py-7">
      <ul className="sr-only">
        {niches.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="marquee relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
        <div className="marquee-track flex w-max" style={{ ["--marquee-duration" as string]: "45s" }}>
          <Row items={niches} />
          <Row items={niches} />
        </div>
      </div>
      {NICHES.length > 0 ? (
        <nav
          aria-label={t("nicheLinksLabel")}
          className="mx-auto mt-6 flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-2 px-4 text-sm sm:px-6"
        >
          <span className="text-ink-muted">{t("nicheLinksLabel")}:</span>
          {NICHES.map((niche) => (
            <Link
              key={niche.id}
              to={niche.path}
              data-cta=""
              className="rounded-full border border-brand-primary/12 bg-brand-bg px-4 py-1.5 font-medium text-brand-primary transition-colors hover:border-teal-strong hover:bg-teal-soft"
            >
              {niche[locale].name}
            </Link>
          ))}
        </nav>
      ) : null}
    </section>
  );
}
